import {ProjectTree} from './AppProjectTree';
import {SearchInput} from './AppSearchInput'
import {AppSearchAdvancedItem} from './AppSearchAdvancedItem'
import {MetadataOption} from 'api'

export interface AppSearchItemProps{
    placeholder?:string
    lable?:string
    lableWidth?:number
    itemWidth?:number
    keyName?:string   // 如果是区间范围，则分为两个key值，后缀叫Min ,Max
    field?:string    // 如果是多个，则用|分割
    dataType?:string 
    opr?:string  // 链接条件 操作符号
    projectTreeScene?:number
}

export interface AppSearchAdvancedItemProps extends AppSearchItemProps{
    lable?:string
    itemType?:string
    format?:string
    options?:MetadataOption[]
}

export const AppSearchItem = {
    ProjectTree,
    SearchInput,
    Advanced:AppSearchAdvancedItem
}






// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/index.tsx